/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Toolbar Zoom In Icon component.
 */
export const MapToolbarZoomInIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5 12H19.15' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M12 19.15V5' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default MapToolbarZoomInIcon;
